// Affichage d'un guide écrit en Markdown (23/10/2026) : sous-ensemble utile aux
// guides — titres, paragraphes, listes à puces et numérotées (imbriquées),
// tableaux, gras, italique. Rendu en éléments React, jamais en HTML brut.

// Gras **x**, italique *x* ; le reste en texte
function inline(text, keyBase) {
  const out = [];
  const re = /\*\*([^*]+)\*\*|\*([^*]+)\*/g;
  let last = 0, m, i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(m[1] != null ? <strong key={`${keyBase}-${i++}`}>{m[1]}</strong> : <em key={`${keyBase}-${i++}`}>{m[2]}</em>);
    last = re.lastIndex;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

const indentOf = (l) => l.match(/^ */)[0].length;
const isItem = (l) => /^\s*(-|\d+\.)\s+/.test(l);

// Liste (et sous-listes) à partir de la ligne i ; renvoie [élément, ligne suivante]
function parseList(lines, i, key) {
  const base = indentOf(lines[i]);
  const ordered = /^\s*\d+\./.test(lines[i]);
  const items = [];
  while (i < lines.length && isItem(lines[i]) && indentOf(lines[i]) === base) {
    const text = lines[i].replace(/^\s*(-|\d+\.)\s+/, '');
    i++;
    let child = null;
    if (i < lines.length && isItem(lines[i]) && indentOf(lines[i]) > base) [child, i] = parseList(lines, i, `${key}-${items.length}`);
    items.push(<li key={items.length} style={{ margin: "3px 0" }}>{inline(text, `${key}-${items.length}`)}{child}</li>);
  }
  const Tag = ordered ? "ol" : "ul";
  return [<Tag key={key} style={{ paddingLeft: 22, margin: "6px 0 10px" }}>{items}</Tag>, i];
}

const cells = (l) => l.trim().replace(/^\||\|$/g, '').split('|').map(c => c.trim());

export default function MarkdownView({ markdown }) {
  const lines = String(markdown || '').replace(/\r\n/g, '\n').split('\n');
  const blocks = [];
  let i = 0;
  while (i < lines.length) {
    const l = lines[i];
    if (!l.trim()) { i++; continue; }
    const h = l.match(/^(#{1,3})\s+(.*)$/);
    if (h) {
      const size = { 1: 22, 2: 17, 3: 15 }[h[1].length];
      blocks.push(<div key={i} role="heading" aria-level={h[1].length} style={{ fontSize: size, fontWeight: 700, margin: h[1].length === 1 ? "0 0 12px" : "22px 0 8px", color: "var(--text-primary)" }}>{inline(h[2], `h${i}`)}</div>);
      i++; continue;
    }
    if (isItem(l)) { const [el, next] = parseList(lines, i, `l${i}`); blocks.push(el); i = next; continue; }
    if (l.trim().startsWith('|') && i + 1 < lines.length && /^\s*\|?\s*-{3,}/.test(lines[i + 1])) {
      const head = cells(l);
      const rows = [];
      i += 2;
      while (i < lines.length && lines[i].trim().startsWith('|')) { rows.push(cells(lines[i])); i++; }
      blocks.push(
        <div key={`t${i}`} style={{ overflowX: "auto", margin: "8px 0 14px" }}>
          <table className="table" style={{ width: "100%", fontSize: 12.5 }}>
            <thead><tr>{head.map((c, k) => <th key={k} style={{ textAlign: "left" }}>{inline(c, `th${i}-${k}`)}</th>)}</tr></thead>
            <tbody>{rows.map((r, n) => <tr key={n}>{r.map((c, k) => <td key={k} style={{ verticalAlign: "top" }}>{inline(c, `td${i}-${n}-${k}`)}</td>)}</tr>)}</tbody>
          </table>
        </div>
      );
      continue;
    }
    // Paragraphe : lignes consécutives non vides
    const para = [];
    while (i < lines.length && lines[i].trim() && !isItem(lines[i]) && !/^#{1,3}\s/.test(lines[i]) && !lines[i].trim().startsWith('|')) { para.push(lines[i].trim()); i++; }
    blocks.push(<p key={`p${i}`} style={{ margin: "6px 0 10px", lineHeight: 1.55 }}>{inline(para.join(' '), `p${i}`)}</p>);
  }
  return <div style={{ fontSize: 13.5, color: "var(--text-primary)", maxWidth: 920 }}>{blocks}</div>;
}
